import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      textAlign: 'center',
      padding: '2rem'
    }}>
      <h1 style={{ fontSize: '6rem', margin: '0', color: '#e74c3c' }}>404</h1>
      <h2 style={{ fontSize: '1.5rem', margin: '0.5rem 0 1rem', color: '#333' }}>
        Page Not Found
      </h2>
      <p style={{ color: '#666', marginBottom: '2rem', maxWidth: '400px' }}>
        The page you are looking for doesn't exist or has been moved.
      </p>
      <Link
        to="/"
        style={{
          padding: '0.75rem 2rem',
          backgroundColor: '#3498db',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '5px',
          fontSize: '1rem'
        }}
      >
        Go Home
      </Link>
    </div>
  );
};

export default NotFound;
